import { IDepartmentReceivers, IInfo, IUserV3 } from '../models/users.interface';

import { IProcessV3 } from '@literax/components/platform/profiles/types/user-ptofiles';
import { IAPIResponseError } from '@literax/models/http/api/error.model';
import {
  IPaginationV3,
  IQueryParameters
} from '@literax/models/pagination.model';
import { IProfile } from '../../profiles/models/profiles';
import { UserKindEnum } from '../enums/user-kind.enum';

export interface ICLientUsersState {
  usersV3: IUserV3[];
  info: IInfo;
  userIdEdit: number;
  errorLogin: IAPIResponseError;
  errors: unknown;
  erroRegister: IAPIResponseError;
  sortColumn: string;
  userKind: UserKindEnum;
  profiles: IProfile[];
  dashboardV3: IProcessV3;
  departmentReceivers: IDepartmentReceivers[];
  paginationV3: IPaginationV3;
  queryParameters: IQueryParameters;
}

export const initialClientUserState: ICLientUsersState = {
  info: null,
  userIdEdit: null,
  errors: {},
  errorLogin: {
    error: {
      title: '',
      status: null,
      detail: '',
      code: null,
    },
    success: null,
  },
  erroRegister: {
    error: {
      title: '',
      status: null,
      detail: '',
      code: null,
    },
    success: null,
  },
  sortColumn: 'id:desc',
  userKind: null,
  profiles: [],
  dashboardV3: null,
  departmentReceivers: [],
  usersV3: [],
  paginationV3: null,
  queryParameters: {
    pageNumber: 1,
    pageSize: 10,
    sortField: null,
    filterFields: [],
  },
};
